import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import Layout from 'components/Layout';
import { AppContext } from 'context';
import NoPaperPageContent from 'components/Generic/NoPaperPageContent';
import { colors } from 'theme';
import UserProfile from './UserProfile';

const useStyles = makeStyles({
  container: {
    marginLeft: '8em',
  },
  userName: {
    color: colors.primary,
  },
});

const UserProfilePage: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const context = useContext(AppContext);
  const user = context.user;
  const userName = user ? `${user.firstName} ${user.lastName}` : '';

  return (
    <Layout noMenu>
      <div className={classes.container}>
        <NoPaperPageContent
          title={
            <div>
              {t('userProfile.title')} <span className={classes.userName}>{userName}</span>
            </div>
          }
        >
          <UserProfile />
        </NoPaperPageContent>
      </div>
    </Layout>
  );
};
export default UserProfilePage;
